import React, { createRef } from 'react';
import { observer } from 'mobx-react';
import Icon from '@ant-design/icons';
import { Popover, Badge, Tooltip } from 'antd';
import intl from 'react-intl-universal';
import { store } from '@/store/store.index';
import { windowMessage } from '@/utils/windowMessage'
import { ReactComponent as NotificationIcon } from '@/assets/Collaboration/notification.svg';
import {
  OPEN_FILE_LOCAL,
} from '../viewer/ui/constants/openfile.constants';
import {
  NOTIFICATION_BELL,
} from 'Components/viewer/ui/constants/user.more.constants';
import './NotificationPopover.scss'
@observer
class NotificationPopover extends React.Component {
  state = {
    visible: false,
  }

  constructor(props) {
    super(props);
    this.iframe = createRef();
  }

  addListener() {
    const { href, origin } = store.collaborationStore.notificationIFrameSrc;
    if (!href) return;

    windowMessage.addListener(origin, async ({ data }) => {
      if (!data) return;

      const { func } = data;
      if (!func || typeof func !== 'string') return;

      switch (func.toLowerCase()) {
        case 'downloadfile':
          const { fileLink, docName, reviewSessionID } = data;
          if (!fileLink || typeof fileLink !== 'string') return;

          if(store.appStore.isDisableButton(OPEN_FILE_LOCAL)){
            return ;
          }

          if(store.collaborationStore.reviewSessionID == reviewSessionID) {
            return;
          }
          if (store.appStore.docModified) {
            // const isOK = await store.appStore.onShowWarningMessageAsync({
            //   message: 'aaaaa',
            //   cancel: 'No',
            //   ok: 'Yes',
            // });
            // if (!isOK) return;

            await store.appStore.onShowToSaveBeforeOpenAsync();
          }
          store.historyStore.goToHomePage()
          store.collaborationStore.resetCollaborationData()
          store.collaborationStore.openSharedFile({ fileLink, docName, reviewSessionID });
          store.collaborationStore.setReviewSessionID(reviewSessionID);
          this.setState({
            visible: false,
          });
          break;

          case 'allmessagesarechecked':
          const { url } = data;
          if (!url || typeof url !== 'string') return;

          store.collaborationStore.setUntreatedNotify(0);
          break;

        default:
          break;
      }
    });
  }

  componentDidMount() {
    store.collaborationStore.startNotificationPolling().then();
    this.addListener();
  }
  
  onVisibleChange= (visible) => {
   

    this.setState({
      visible,
    })
    if(visible){
      if(store.appStore.isCollaborationMode()){
        store.userStore.doSendGAEvent({eventKey: NOTIFICATION_BELL, label:'review_mode_upper_right_area'});
      }else{
        store.userStore.doSendGAEventByUser({eventKey:NOTIFICATION_BELL, label:'upper_right_area'})
      }
    }
  }
  closeTips=()=>{
    store.collaborationStore.closeNotification()
  }
  render() {
    const { deadlineTips,isShow_deadlineTips } = store.collaborationStore;
    const tips = <span className='tipsContent'>
      <span>{deadlineTips}</span>
      <span className='close' onClick={this.closeTips}>x</span>
    </span>
    return (
      <div className='NotificationPopover notification-popover-box'>
        <Tooltip
          overlayClassName='blackBGC NotificationToolTips'
          visible={isShow_deadlineTips}
          placement="bottom" title={tips}
          // getPopupContainer={triggerNode => triggerNode.parentNode}
        >
          <Popover
          // getPopupContainer={triggerNode => triggerNode.parentNode}
          placement="bottomRight" 
          arrowPointAtCenter
          zIndex={9999}
          destroyPopupOnHide={true}
          visible={this.state.visible}
          overlayClassName='popoverContainer'
          id="user-dropdown-menu"
          content={<iframe
            ref={this.iframe}
            src={store.collaborationStore.notificationIFrameSrc.href}
            frameBorder={0}
            width={400}
            height={490}
            name="notificationIFrame"
          />}
          trigger="click"
          onVisibleChange={this.onVisibleChange}
          >
          <Tooltip title={intl.get('HeaderContainer.Notification')}>
          <a className="icon-btn" tabIndex="0" role="button" aria-label={intl.get('HeaderContainer.Notification')} aria-controls="header-notification" aria-expanded={this.state.visible}>
            <Badge count={store.collaborationStore.notificationStatistic.untreatedNotify} dot={true} offset={[-7, 7]}>
              <Icon component={NotificationIcon} />
            </Badge>
          </a>
          </Tooltip>
        </Popover>
        </Tooltip>
      </div>
    );
  }
}

export default NotificationPopover;
